import { render, staticRenderFns } from "./CatalogListPagination.vue?vue&type=template&id=ad2c42b2&scoped=true"
import script from "./CatalogListPagination.vue?vue&type=script&lang=js"
export * from "./CatalogListPagination.vue?vue&type=script&lang=js"
import style0 from "./CatalogListPagination.vue?vue&type=style&index=0&id=ad2c42b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2c42b2",
  null
  
)

export default component.exports